define('models/pages/wishlist/wishes/modal/content',['require','jquery','underscore','mediator','lib/utils','models/base/model','models/base/collection'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        mediator = require('mediator'),
        utils = require('lib/utils'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection');

    function debug() {
        // console.log.apply(console, arguments);
    }

    function nameToText(item){
        return {
            id: item.id,
            text: item.name
        };
    }

    function codeToText(item){
        return {
            id: item.id,
            text: item.code
        };
    }

    function valueToText(item){
        return {
            id: item,
            text: item
        };
    }

    function urlParams(fields) {
        return function() {
            var src = this.parent;
            return _.reduce(fields, function(memo, key) {
                var value = src.get(key);
                if (value) {
                    memo[key] = value;
                }
                return memo;
            }, {});
        };
    }

    var SelectItemModel = Model.extend({
        parse: nameToText
    });

    var SelectItemTextModel = Model.extend({
        parse: valueToText
    });

    var SelectItemCodeModel = Model.extend({
        parse: codeToText
    });


    var CountryCol = Collection.extend({
        urlPath: '/api/trade/country',
        model: SelectItemModel
    });

    var GoodsCategoryCol = Collection.extend({
        urlPath: '/api/trade/goods-category',
        model: SelectItemModel,
        urlParams: urlParams(['countryId'])
    });

    var GoodsTypeCol = Collection.extend({
        urlPath: '/api/trade/goods-type',
        model: SelectItemModel,
        urlParams: urlParams(['countryId', 'goodsCategoryId'])
    });

    var GoodsCol = Collection.extend({
        urlPath: '/api/trade/goods',
        model: SelectItemModel,
        urlParams: urlParams(['countryId', 'goodsCategoryId', 'goodsTypeId'])
    });

    var GoodsLengthCol = Collection.extend({
        urlPath: '/api/trade/goods-length',
        model: SelectItemTextModel
    });

    var VendorCol = Collection.extend({
        urlPath: '/api/trade/vendor',
        model: SelectItemTextModel,
        urlParams: urlParams(['countryId', 'goodsCategoryId'])
    });

    var CurrencyCol = Collection.extend({
        urlPath: '/api/currency',
        model: SelectItemCodeModel
    });

    var SellerCol = Collection.extend({
        urlPath: '/api/trade/seller',
        model: SelectItemModel,
        urlParams: urlParams(['countryId', 'goodsCategoryId'])
    });

    var VendorCountriesCol = Collection.extend({
        urlPath: '/api/country',
        model: SelectItemModel
    });


    var WishlistModalContent = Model.extend({
        idAttribute: 'id',
        urlPath: function() {
            var id = this.get(this.idAttribute);
            return '/api/wishlist' + (id ? ('/' + id) : '');
        },

        defaults: {
            active: false,
            activeUntil: null,
            countryId: null,
            favoriteSellers: false,
            goodsCategoryId: null,
            goodsTypeId: null,
            favoriteGoods: false,
            freshness: null,
            quality: null,
            minLot: null,
            price: null,
            currencyId: null,
            sellers: [],
            goods: [],
            vendorCountries: [],
            vendors: [],
            lengths: []
        },

        toJSON: function() {
            var res = _.compactObject(_.cloneDeep(this.attributes));

            if (typeof res.sellers === 'string') {
                res.sellers = res.sellers.split(',');
            }
            if (typeof res.goods === 'string') {
                res.goods = res.goods.split(',');
            }
            if (typeof res.vendorCountries === 'string') {
                res.vendorCountries = res.vendorCountries.split(',');
            }
            if (typeof res.vendors === 'string') {
                res.vendors = res.vendors.split(',');
            }
            if (typeof res.lengths === 'string') {
                res.lengths = res.lengths.split(',');
            }

            debug('toJSON', res);
            return res;
        },

        initialize: function() {
            Model.prototype.initialize.apply(this, arguments);

            this.countryId = new CountryCol([]);
            this.countryId.parent = this;

            this.goodsCategoryId = new GoodsCategoryCol([]);
            this.goodsCategoryId.parent = this;

            this.goodsTypeId = new GoodsTypeCol([]);
            this.goodsTypeId.parent = this;

            this.goods = new GoodsCol([]);
            this.goods.parent = this;

            this.lengths = new GoodsLengthCol([]);
            this.lengths.parent = this;

            this.vendors = new VendorCol([]);
            this.vendors.parent = this;

            this.sellers = new SellerCol([]);
            this.sellers.parent = this;

            this.currencyId = new CurrencyCol([]);
            this.currencyId.parent = this;

            this.vendorCountries = new VendorCountriesCol([]);
            this.vendorCountries.parent = this;

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 365);

            this.set('activeUntil', tomorrow);

            this.set('currencyId', mediator.user.get('organization').currencyViewId);
        },
        dispose: function() {
            if (this.disposed) {
              return;
            }
            this.disposeSubModels();

            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data){
            debug('parse wishlist item', data);
            data.activeUntil = new Date(data.activeUntil);
            return data;
        },
        loadCountryIdDeps: function(clear) {
            var model = this;

            this.resetCountryIdDeps(clear);

            if (!model.get('countryId')) {
                return $.when();
            }

            debug('* goodsCategoryId.fetch *');
            return model.goodsCategoryId.fetch().then(function() { debug('- goodsCategoryId.fetched -'); })
                .then(function() {
                    return model.loadGoodsCategoryIdDeps(clear);
                });
        },
        resetCountryIdDeps: function(clear) {
            var model = this;

            if (clear) {
                model.set({
                    'goodsCategoryId': null
                }, { silent: false });
            }

            model.goodsCategoryId.reset([]);

            this.resetGoodsCategoryIdDeps(clear);
        },
        loadGoodsCategoryIdDeps: function(clear) {
            var model = this;

            this.resetGoodsCategoryIdDeps(clear);

            if (!model.get('countryId') || !model.get('goodsCategoryId')) {
                return $.when();
            }

            debug('* goodsTypeId.fetch *');
            return model.goodsTypeId.fetch().then(function() { debug('- goodsTypeId.fetched -'); })
                .then(function() {
                    debug('* sellers.fetch *');
                    return model.sellers.fetch().then(function() { debug('- sellers.fetched -'); });
                })
                .then(function() {
                    debug('* vendors.fetch *');
                    return model.vendors.fetch().then(function() { debug('- vendors.fetched -'); });
                })
                .then(function() {
                    return model.loadGoodsTypeIdDeps(clear);
                });
        },
        resetGoodsCategoryIdDeps: function(clear) {
            var model = this;

            if (clear) {
                model.set({
                    'goodsTypeId': null,
                    'sellers': null,
                    'vendors': null,
                }, { silent: false });
            }

            model.goodsTypeId.reset([]);
            model.sellers.reset([]);
            model.vendors.reset([]);
            this.resetGoodsTypeIdDeps(clear);
        },
        loadGoodsTypeIdDeps: function(clear) {
            var model = this;

            this.resetGoodsTypeIdDeps(clear);

            if (!model.get('countryId') || !model.get('goodsCategoryId') || !model.get('goodsTypeId')) {
                return $.when();
            }

            debug('* goods.fetch *');
            return model.goods.fetch().then(function() { debug('- goods.fetched -'); });
        },
        resetGoodsTypeIdDeps: function(clear) {
            var model = this;

            if (clear) {
                model.set({
                    'goods': null
                }, { silent: false });
            }

            model.goods.reset([]);
        },
        load: function() {
            var model = this;

            function loadDetails() {
                debug('* lengths.fetch *');
                return model.lengths.fetch().then(function() { debug('- lengths.fetched -'); })
                    .then(function() {
                        debug('* countryId.fetch *');
                        return model.countryId.fetch().then(function() { debug('- countryId.fetched -'); });
                    })
                    .then(function() {
                        debug('* currencyId.fetch *');
                        return model.currencyId.fetch().then(function() { debug('- currencyId.fetched -'); });
                    })
                    .then(function() {
                        debug('* vendorCountries.fetch *');
                        return model.vendorCountries.fetch().then(function() { debug('- vendorCountries.fetched -'); });
                    });
            }

            function loadDetailsDepended() {
                return model.loadCountryIdDeps();
            }

            function loadData() {
                if (model.isNew()) {
                    return loadDetails();
                } else {
                    debug('wishlist.fetch');
                    return model.fetch({ silent: true }).then(function() { debug('- wishlist.fetched -'); })
                        .then(function() {
                            return loadDetails()
                                .then(loadDetailsDepended);
                        });
                }
            }

            return loadData()
                .then(function() {
                    debug('ALL FETCHED');
                    model.trigger('loaded');
                });
        }
    });

    return WishlistModalContent;
});

